document.body.addEventListener("click", function(event) {
    console.log("eventcurrent->", event.target);
    const update = document.querySelector(".topupdate-wrapper");
    const parentTarget = event.target.closest(".all-update");
    if (parentTarget) {
        console.log("parentTarget->", parentTarget);
        console.log("parentTargetClassList->", parentTarget.classList[3]);
        index = parentTarget.classList[3].split("-")[2];
        targetUpdateContainer = document.querySelector(`.topupdate-wrapper-${index}`);
        $(`.topupdate-wrapper-${index}`).slideToggle(280);
        $(`.update-btn-${index}`).toggleClass("arrow-animate");
        console.log("targetUpdateContainer->", targetUpdateContainer);
    // apply toggle class to
    // targetUpdateContainer.slideToggle(280);
    // targetUpdateContainer.style.display =
    //   targetUpdateContainer.style.display == "inline-flex"
    //     ? "none"
    //     : "inline-flex";
    }
});

//# sourceMappingURL=index.8aaa31e1.js.map
